import { createFileRoute, Outlet } from "@tanstack/react-router";

import { ProtectedProvider } from "@/features/auth/_providers/protected-provider";

/**
 * Layout of `/document`, the teammate documents: open to any signed-in person, whatever their role. A signed-out
 * visitor is sent to sign-in and comes back to the page they asked for.
 */
export const Route = createFileRoute("/document")({
  component: DocumentLayout,
});

function DocumentLayout() {
  return (
    <ProtectedProvider>
      <Outlet />
    </ProtectedProvider>
  );
}
